import * as React from 'react';
// import cx from 'classnames';
// import PaymentFundsSummary from '../plan/paymentFundsSummary';
import DetailsFields from '../details';
import SummaryOverview from '../plan/summaryOverview';
import { Api } from '../../api';
import Loader from '../ui/Loader';
import { UserPersonalDetails } from '../../models/userdetails';
import { CartResponse } from '../../models/cart';
import { Direction } from '../../constants';

interface Props {
  bankDetails: object;
  personalDetails: object;
  hideEdit: boolean;
  parentProps: object;
  investmentType: Direction;
  handleEditAmount: Function;
  onEditFunds: Function;
  hideEditFunds?: boolean;
  onEdit: () => void;
  isPaymentMode: boolean;
  url: any;
  handleBack: () => string;
  trackLabel?: string;
  doPennyDrop?: (userDetails: any, cb: any) => any;
  bankErrorMsg?: string;
  isBankVerified?: boolean;
  scheduleLater?: boolean;
  scheduleModal?: () => void;
  dissmissScheduleModal?: () => void;
  dismissModal?: () => void;
  pennyDropPending?: boolean;
  isOtpVerified?: boolean;
  showOtpScreen?: () => void;
  investmentToken: string;
}

interface State {
  userPersonalDetails: UserPersonalDetails;
  kycCheck: any;
  cart: CartResponse;
  investmentOwnerCode: string;
  investmentOwnerCodeHasError: boolean;
  SipDateHasError: boolean; // Check if SIP date has been selected or not
}

const api = new Api();
const { Component } = React;

class InvestFlowView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      userPersonalDetails: null,
      kycCheck: null,
      cart: null,
      investmentOwnerCode: 'SELF', // Selected SELF as default
      investmentOwnerCodeHasError: false,
      SipDateHasError: false,
    };
  }

  public async componentDidMount() {
    Promise.all([api.getUserDetails(), api.getCart()]).then(
      ([userDetails, cartDetails]: any[]) => {
        this.setState(
          {
            userPersonalDetails:
              userDetails.response.entity.userPersonalDetails,
            cart: cartDetails.response,
          },
          this.getKYCStatus
        );
      }
    );
  }

  private getKYCStatus = async () => {
    const { personalDetails } = this.props;
    if (personalDetails) {
      const { pan = '' } = personalDetails;
      if (pan && pan.length === 10) {
        const response = await api.handleKycCheck(
          { pan },
          'investment-flow-view-component'
        );
        this.setState({
          kycCheck: response,
        });
      }
    }
  };

  private toggleInvestmentOwnerCodeHasError = (value: boolean) => {
    this.setState({
      investmentOwnerCodeHasError: value,
    });
  };

  private toggleSIPDateSelectorHasError = (value: boolean) => {
    this.setState({
      SipDateHasError: value,
    });
  };

  private handleInvestmentOwnerChange = (
    e: React.FormEvent<HTMLSelectElement>
  ) => {
    e.persist();
    const { value } = e.target;
    this.setState({
      investmentOwnerCode: value,
    });
  };

  public render() {
    const {
      bankDetails,
      personalDetails,
      parentProps,
      investmentType,
      handleEditAmount,
      onEditFunds,
      hideEditFunds,
      onEdit,
      isPaymentMode,
      url: {
        query: { useRazorpay },
      },
      handleBack,
      doPennyDrop,
      bankErrorMsg,
      isBankVerified,
      scheduleLater,
      scheduleModal,
      dissmissScheduleModal,
      dismissModal,
      pennyDropPending,
      isOtpVerified,
      showOtpScreen,
      investmentToken,
    } = this.props;
    const {
      investmentOwnerCode,
      investmentOwnerCodeHasError,
      SipDateHasError,
    } = this.state;

    const { kycCheck, cart } = this.state;

    // Display only allowed SIP dates for funds
    // TODO: make changes for bucket plans
    const { bucketData, selectedFund } = parentProps;
    let { allowedSipDates } = parentProps;
    let sipDates = ['05', '10', '20'];
    if (Object.keys(bucketData).length === 0) {
      if (!allowedSipDates) {
        allowedSipDates = selectedFund.allowedSipDates;
      }
      sipDates = sipDates.filter((date) =>
        allowedSipDates.includes(Number(date))
      );
    }

    if (!cart) {
      return (
        <div className={'p15'}>
          <Loader size="40px" />
        </div>
      );
    }

    return (
      <div className={'row'}>
        <DetailsFields
          className="large-12"
          // className={cx({
          //   'large-7': isPaymentMode && useRazorpay === '1',
          //   'large-12': !isPaymentMode,
          //   'large-6': isPaymentMode && useRazorpay !== '1',
          // })}
          {...parentProps}
          investmentType={investmentType}
          handleEditAmount={handleEditAmount}
          onEditFunds={onEditFunds}
          hideEditFunds={hideEditFunds}
          investmentOwnerCode={investmentOwnerCode}
          toggleInvestmentOwnerCodeHasError={
            this.toggleInvestmentOwnerCodeHasError
          }
          SipDateHasError={SipDateHasError}
          toggleSIPDateSelectorHasError={this.toggleSIPDateSelectorHasError}
          investmentOwnerCodeHasError={investmentOwnerCodeHasError}
          cart={cart}
          kycCheck={kycCheck}
          handleBack={handleBack}
          doPennyDrop={(userDetails, cb) => doPennyDrop(userDetails, cb)}
          pennyDropPending={pennyDropPending}
          bankErrorMsg={bankErrorMsg}
          isBankVerified={isBankVerified}
          trackLabel={this.props.trackLabel}
          isPaymentMode={isPaymentMode}
          sipDates={sipDates}
          personalDetails={personalDetails}
          handleInvestmentOwner={this.handleInvestmentOwnerChange}
          bankDetails={bankDetails}
          scheduleModal={scheduleModal}
          dissmissScheduleModal={dissmissScheduleModal}
          scheduleLater={scheduleLater}
          dismissModal={dismissModal}
          isOtpVerified={isOtpVerified}
          showOtpScreen={showOtpScreen}
          investmentToken={investmentToken}
        />
        {isPaymentMode && useRazorpay === '1' ? (
          <div className="large-5 columns">
            <SummaryOverview
              bankDetails={bankDetails}
              onEdit={onEdit}
              hideEdit={hideEditFunds}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default InvestFlowView;



// WEBPACK FOOTER //
// ./components/invest/investFlowView.tsx